import React from "react";
import { MdEdit, MdDelete, MdRestore } from "react-icons/md";
import styles from "./TableBody.module.css";

interface Column {
  key: string;
  label: string;
  className?: string;
  headerClassName?: string;
}

interface TableBodyProps {
  currentItems: any[];
  columns: Column[];
  getNestedValue: (obj: any, path: string) => any;
  renderTableBody: () => JSX.Element;
  onEditItem?: (item: any) => void;
  onDeleteItem?: (item: any) => void;
  onReactiveItem?: (item: any) => void;
  keyActive?: string | undefined;
}

const TableBody: React.FC<TableBodyProps> = ({
  currentItems,
  columns,
  getNestedValue,
  renderTableBody,
  onEditItem,
  onDeleteItem,
  onReactiveItem,
  keyActive,
}) => {
  const isInactiveTable = keyActive === "inactivo";

  return (
    <tbody>
      {currentItems.length > 0 ? (
        currentItems.map(item => (
          <tr key={item.id}>
            {columns.map((col) => {
              const value = getNestedValue(item, col.key);
            
              let displayValue;
            
              if (value === null || value === undefined || value === "") {
                displayValue = <div className="d-flex justify-content-center"><em className="text-muted">—</em></div>
              } else if (typeof value === "object") {
                displayValue = JSON.stringify(value);
              } else {
                displayValue = value;
              }
            
              return (
                <td
                  key={col.key}
                  className={col.className}
                  title={typeof value === "string" ? value : ""}
                >
                  {displayValue}
                </td>
              );
            })}
            <td className={styles.acciones}>
              <MdEdit
                title="Editar"
                className={styles.editIcon}
                onClick={() => onEditItem?.(item)}
              />
              {!isInactiveTable && (
                <MdDelete
                  title="Eliminar"
                  className={styles.deleteIcon}
                  onClick={() => onDeleteItem?.(item)}
                />
              )}
              {isInactiveTable && (
                <MdRestore 
                  title="Reactivar"
                  className={styles.reactiveIcon}
                  onClick={() => onReactiveItem?.(item)}
                />
              )}
            </td>
          </tr>
        ))
      ) : (
        renderTableBody() || <tr><td colSpan={columns.length + 1}>No se encontraron resultados</td></tr>
      )}
    </tbody>
  );
};

export default TableBody;
